import React, { useEffect } from "react";
import { useVerifyEmail } from "./hooks";

interface Props {
    oobCode: string | null;
}

const EmailVerification: React.FC<Props> = ({ oobCode }) => {
    const onVerifyEmail = useVerifyEmail();

    useEffect(() => {
        onVerifyEmail(oobCode);
    }, []);

    return null;
};

export default EmailVerification;
